import { BookOpenIcon, DevicePhoneMobileIcon, GlobeAltIcon } from '@heroicons/react/20/solid'

const features = [
  {
    name: 'Website Tasarımı.',
    description: "Size özel modern web siteleri tasarlıyoruz. Sitenizdeki her şeyi sizin istediğiniz gibi tasarlıyoruz.",
    icon: GlobeAltIcon
  },
  {
    name: 'Mobil Uygulama Tasarımı.',
    description: "Size özel modern mobil uygulamalar tasarlıyoruz. Uygulamanızda her şeyi sizin istediğiniz gibi tasarlıyoruz.",
    icon: DevicePhoneMobileIcon
  },
  {
    name: "Yazılım Kursları.",
    description: "Her yaşta ve sektörde eğitim alarak kendinizi yenilemenize ve toplumun ihtiyaç duyduğu alanlarda olmanıza imkan sunmaktayız.",
    icon: BookOpenIcon
  }
]

export default function Features() {
  return (
    <div className="overflow-hidden py-24 sm:py-32">
      <div className="container mx-auto px-4">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pr-8 lg:pt-4">
            <div className="lg:max-w-lg">
              <h2 className="text-base font-semibold leading-7 text-indigo-600" data-aos="fade-right">Neler yapıyoruz?</h2>
              <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl" data-aos="fade-right">Yazılım alanında neler yapıyoruz?</p>
              <p className="mt-6 text-lg leading-8 text-gray-600" data-aos="fade-right">
                Yazılım alanında <span className='font-bold'>Meta Akdeniz</span> olarak neler yapıyoruz? İşte cevabı:
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="relative pl-9" data-aos="fade-right">
                    <dt className="inline font-semibold text-gray-900">
                      <feature.icon className="absolute left-1 top-1 h-5 w-5 text-indigo-600" aria-hidden="true" />
                      {feature.name}
                    </dt>{' '}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
          <img
            src="/icons/features.svg"
            alt="features image"
            className="w-[38rem] h-[35rem] -mt-24 sm:w-[57rem] md:-ml-4 lg:-ml-0"
            width={2432}
            height={500}
            data-aos="fade-top"
          />
        </div>
      </div>
    </div>
  )
}
